export default {
    products   : {
        list            : [],
        page            : 1,
        sort            : 'priceLowToHigh',
        filters         : {
            category    : null,
            brands      : [],
            tags        : []
        },
        cart    : {
            products    : [],
            totalPrice  : 0
        }
    }
}